<template>
  <div class="mainContent db-page">
    <div class="top-control">
      <div class="tab-content">
        <div class="dashboard-hpo" v-if="renderComponent">
          <muuri-grid id="grid" ref="muurigrid" :options="{dragEnabled: false}">
             <muuri-grid-item style="width: 100% !important; max-width: auto !important" v-if="!storeTQRole">
                <order-summary></order-summary>
             </muuri-grid-item>
              <muuri-grid-item style="width: 100% !important; max-width: auto !important" v-if="!storeTQRole">
                <deposit-summary></deposit-summary>
             </muuri-grid-item>
             <muuri-grid-item style="width: 100% !important; max-width: auto !important">
                <bigpackage></bigpackage>
             </muuri-grid-item>
          </muuri-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configs from '@/configs';
import clickoutside from '@/directives/clickoutside';
import Bigpackage from '@/components/dashboard/Bigpackage';
import OrderSummary from '@/components/dashboard/OrderSummary';
import DepositSummary from '@/components/dashboard/DepositSummary';
import { MuuriGridItem } from 'vue-muuri-grid';

export default {
  directives: { clickoutside },
  components:{
    OrderSummary,
    DepositSummary,
    Bigpackage,
    MuuriGridItem,
  },
  computed: {
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    storeTQRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ2) == configs.ROLE_TYPE.StoreTQ2;
    },
  },
  data() {
    return {
      showModal: false,
      renderComponent: true,
      popupModalName: '',
      popupModalTitle: '',
      popupModalHeight: 600,
    }
  },
  mounted() {
    this.$root.$on('zoomChart', (widget) => {
      this.popupModalName = widget.widgetName;
      this.popupModalTitle = widget.widgetTitle;
      this.popupModalHeight = window.innerHeight * 0.6;
    });
  }
}
</script>
<style>
.modal-open{padding-right: 0 !important; }
.modal-backdrop{ z-index: 999998;}
.close:focus{outline:none}
</style>